function LevelDisplay ({ level }) {
    return (
        <div className="info-display">
            Level: { level }
        </div>
    );
}

export default LevelDisplay;